
























import { handleError } from "@/lib/utility/handleError";
import { IPartnerBanking } from "@/models/partner-banking.entity";
import Vue from "vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import SideCard from "../utility/SideCard.vue";
import PartnerBankingDetail from "./PartnerBankingDetail.vue";

@Component({
  components: { SideCard, PartnerBankingDetail, LatestEntriesCardEmpty }
})
export default class PartnerBankingSideCard extends mixins(Vue) {
  @Prop()
  value!: IPartnerBanking;

  get fullscreenBreakpoint() {
    return this.$vuetify.breakpoint.width < 1500;
  }

  isLoading = false;

  async mounted() {
    try {
      this.isLoading = true;

      await this.value.fetch();
    } catch (error) {
      handleError(error);
      this.close();
    } finally {
      this.isLoading = false;
    }
  }

  close() {
    this.$emit("close");
  }
}
